const news = [
	{
		//消息通知
		path: '/news',
		name: 'news',
		component: resolve => require(['@/views/other/news/index'], resolve),
		meta: {
			isHide: true,
			isPermission: true
		}
	},
	{
		//消息通知
		path: '/newsDetails',
		name: 'newsDetails',
		component: resolve => require(['@/views/other/newsDetails/index'], resolve),
		meta: {
			isHide: true
		}
	}
]

export default news
